/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Price_First_MonthInputs */

const en_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/first month`)
};

const ar_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/الشهر الأول`)
};

const de_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/erster Monat`)
};

const es_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/primer mes`)
};

const fr_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/premier mois`)
};

const it_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/primo mese`)
};

const ja_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/初月`)
};

const ko_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/첫 달`)
};

const pt_br_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/primeiro mês`)
};

const ru_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/первый месяц`)
};

const th_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/เดือนแรก`)
};

const tr_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ilk ay`)
};

const zh_cn_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/首月`)
};

const zh_tw_subscription_price_first_month = /** @type {(inputs: Subscription_Price_First_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/首月`)
};

/**
* | output |
* | --- |
* | "/first month" |
*
* @param {Subscription_Price_First_MonthInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_price_first_month = /** @type {((inputs?: Subscription_Price_First_MonthInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Price_First_MonthInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_price_first_month(inputs)
	if (locale === "ar") return ar_subscription_price_first_month(inputs)
	if (locale === "de") return de_subscription_price_first_month(inputs)
	if (locale === "es") return es_subscription_price_first_month(inputs)
	if (locale === "fr") return fr_subscription_price_first_month(inputs)
	if (locale === "it") return it_subscription_price_first_month(inputs)
	if (locale === "ja") return ja_subscription_price_first_month(inputs)
	if (locale === "ko") return ko_subscription_price_first_month(inputs)
	if (locale === "pt_br") return pt_br_subscription_price_first_month(inputs)
	if (locale === "ru") return ru_subscription_price_first_month(inputs)
	if (locale === "th") return th_subscription_price_first_month(inputs)
	if (locale === "tr") return tr_subscription_price_first_month(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_price_first_month(inputs)
	return zh_tw_subscription_price_first_month(inputs)
});